import React, { memo } from 'react';
import CommonSettings from '../gen2_widgets/base/CommonSettings';
import { WidgetSettings, widgetsWithCharts, widgetsWithGridView } from '../WidgetLibraryGen2';
import { useDispatch, useSelector } from 'react-redux';
import AgChartSettings from './ag_chart/AgChartSettings.jsx';
import GridViewSettings from './grid_view/GridViewSettings.jsx';
import { cloneWidget, closeSidebar, openSidebarWidget, saveLayout, saveWidgetSettings, saveWidgetSettingsWithId, updateLayout } from '../redux/dashboardSlice.js';

function WidgetSettingsSidebar({editingId}) {
    const dispatch = useDispatch();
    const widget = useSelector(state => state.dashboard.widgets[editingId]);
    const layout = useSelector(state => state.dashboard.layout);
    const layoutItem = layout[editingId];
    if (!editingId || !widget) return null;
    const Settings = WidgetSettings[widget.widget_type]

    const disconnectClonedWidget = async () => {
        dispatch(closeSidebar());
        const res = await dispatch(cloneWidget({widgetId: editingId, layoutItem, disconnectFromCloned: true}))
        const newLayoutItem = res?.payload?.layout;
        const newLayout = Object.values(layout).map((li) => ({
            ...((li.i === `widget-${editingId}`) ? newLayoutItem : li)
        }));
        await dispatch(updateLayout(newLayout));
        await dispatch(saveLayout());
        await dispatch(openSidebarWidget(res?.payload?.widget?.id))
    }

    return (
        <>
            {(widget.dashboard_count || 1) > 1 && <div className='alert alert-info'>
                <p>{I18n.t('dashboard_widget_cloned_dashboard_count_warning', { count: widget.dashboard_count })}</p>
                <a onClick={disconnectClonedWidget} style={{cursor: 'pointer'}}>{I18n.t('clone_widget_with_current_settings')}</a>
            </div>}
            <Settings widgetId={editingId} />
            {widgetsWithCharts.includes(widget.widget_type) && <AgChartSettings widgetId={editingId} />}
            <CommonSettings widgetId={editingId} />
            {widgetsWithGridView.includes(widget.widget_type) && <GridViewSettings widgetId={editingId} />}
        </>
    );
}

export default memo(WidgetSettingsSidebar);
